import React, { useCallback, useEffect } from 'react';
import { Icon, Tappable } from '@vectord/components';
import cogoToast from 'cogo-toast';
import classNames from 'classnames';

import { useDeleteAcademyTopicAcademyProjectMutation } from 'features/classCreation';
import AcademyProjectChip from '../AcademyProjectChip';
import AcademyProjectDetailsModal from '../AcademyProjectDetailsModal';
import Input from 'components/Input';
import styles from './EditAcademyProjectInput.module.scss';

export default function EditAcademyProjectInput({
  academyTopic,
  isShowingDetails,
  setIsShowingDetails,
}) {
  const { academy_project: academyProject } = academyTopic || {};
  const {
    id: academyProjectId,
    test_id: academyProjectTestId,
    title: academyProjectTitle,
  } = academyProject || {};

  const [deleteAcademyProject, { isSuccess, error, isLoading: isDeleting }] =
    useDeleteAcademyTopicAcademyProjectMutation();

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Case Study is successfully deleted!');
    }
  }, [isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(
        error?.data?.message ||
          'There was some problem in deleting the Case Study. Please try again later!'
      );
    }
  }, [error]);

  const handleRemoveClick = useCallback(() => {
    deleteAcademyProject({
      academyTopicId: academyTopic.id,
      academyProjectId,
    });
  }, [academyProjectId, academyTopic, deleteAcademyProject]);

  return (
    <>
      {academyProjectTestId && (
        <>
          <Input
            value={academyProjectTestId}
            className={styles.input}
            disabled
          />
          <Input
            value={academyProjectTitle}
            className={classNames(styles.input, 'm-h-xs')}
            disabled
          />
          <Tappable
            className={classNames('btn btn-danger', styles.removeButton)}
            onClick={handleRemoveClick}
            disabled={isDeleting}
          >
            <Icon
              name="close"
              className="m-r-xxs"
            />
            Remove
          </Tappable>
        </>
      )}
      {!academyProjectTestId && (
        <AcademyProjectChip academyTopic={academyTopic} />
      )}
      <AcademyProjectDetailsModal
        isOpen={isShowingDetails}
        setOpen={setIsShowingDetails}
        academyTopic={academyTopic}
      />
    </>
  );
}
